@if (showPromotionTopbar()) {
  <app-promotion-bonus-topbar-plus2
    [bonusAmount]="promoFacade.bonusAmount()"
    [visible]="promoFacade.topbarVisible()"
    [totalRounds]="promoFacade.totalRounds()"
    [totalBonuses]="promoFacade.totalBonuses()"
    [promotionBonusScenario]="promoFacade.scenario()"
    [context]="promoFacade.context()"
    [bonusType]="promoFacade.bonusType()"
    [game]="promoFacade.game()"
    [mustClaim]="promoFacade.mustClaim()"
    [promotion]="promoFacade.availablePromotions()?.[0]"
    (closeDialog)="onPromoTopbarClose()"
    (claim)="onPromoTopbarClaim()"
  ></app-promotion-bonus-topbar-plus2>
}

@if (isDesktopView()) {
  @if (showDesktopHeader()) {
    <app-menu-top-bar-plus2></app-menu-top-bar-plus2>
  }
} @else {
  @if (showMobileHeader()) {
    <app-menu-top-bar-mobile
      class="tw-block"
      id="menu-top"
      [class.tw-pointer-events-none]="!mobileHeaderVisible()"
      [isIframe]="hideMenuTop()"
      (toggleEvent)="onToggleSportsMenu()"
      (toggleLoginSideMenuEvent)="onToggleLoginSideMenu()"
      [hideSecondBar]="hideMobileSecondBar()"
      (openGuestDeposit)="onOpenGuestDeposit()"
      [class.bg_casino_v2]="isCasinoOrLive()"
      [hasTransparentBackground]="isCasinoOrLive()"
    ></app-menu-top-bar-mobile>
  }
}
